import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Copy06 = function Copy06(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M7.5 3h7.1c2.2402 0 3.3603 0 4.216.436a4 4 0 0 1 1.748 1.748C21 6.0397 21 7.1598 21 9.4v7.1M6.2 21h8.1c1.1201 0 1.6802 0 2.108-.218a2 2 0 0 0 .874-.874c.218-.4278.218-.9879.218-2.108V9.7c0-1.1201 0-1.6802-.218-2.108a2 2 0 0 0-.874-.874C15.9802 6.5 15.4201 6.5 14.3 6.5H6.2c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C3 8.0198 3 8.58 3 9.7v8.1c0 1.1201 0 1.6802.218 2.108.1917.3763.4977.6823.874.874C4.5198 21 5.08 21 6.2 21"
    })
  }));
};
export default Copy06;